import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import '../styles/pages/resetpassword.css';
import { resetPassword } from '../api/user';

const ResetPasswordPage = () => {
  const { uid, token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
        await resetPassword(newPassword, uid, token);
        navigate("/");
        setSuccess(true);
    } catch (err) {
      alert("Password reset failed.");
    }
  };

  return (
    <div id="reset-password-container">
      {success ? (
        <p>Password reset successful! You can now log in.</p>
      ) : (
        <>
          <h2>Reset Password</h2>
          <input
            type="password"
            value={newPassword}
            placeholder="Enter new password"
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <button className='button' onClick={() => handleSubmit()}>Reset</button>
        </>
      )}
    </div>
  );
};

export default ResetPasswordPage;
